import { render } from "./TriggerBackendTasks.vue?vue&type=template&id=c9559e08"
import script from "./TriggerBackendTasks.vue?vue&type=script&lang=js"
export * from "./TriggerBackendTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__